import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Reveal } from "../components/Reveal";
import { FloorFinder } from "../sections/FloorFinder";
import { useSeo } from "../hooks/useSeo";
import { IMG } from "../data/content";

const ProdukteHero = () => (
  <section data-testid="produkte-hero" className="relative min-h-[68vh] flex items-end overflow-hidden">
    <img
      src={IMG.produkteHeader}
      alt="Moderner Wohnraum mit Holztreppe, Galabau-Blick und warmem Parkettboden"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#2B2B30]/95 via-[#2B2B30]/55 to-[#2B2B30]/30" />
    <div className="container-blum relative z-10 pb-16 pt-40">
      <Reveal>
        <p data-testid="produkte-hero-script" className="font-script text-3xl lg:text-4xl text-[#D7C4B1]">
          Wir realisieren Ihre (T)Räume
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05] tracking-tight mt-3 max-w-3xl">
          Unsere Produkte
        </h1>
        <p className="text-lg text-white/85 mt-5 max-w-2xl leading-relaxed">
          Vom zeitlosen Parkett bis zum pflegeleichten Designbelag – ausgewählte
          Fussböden für jeden Raum, jeden Stil und jeden Anspruch.
        </p>
      </Reveal>
    </div>
  </section>
);

const Intro = () => (
  <section data-testid="produkte-intro" className="py-20 lg:py-28">
    <div className="container-blum max-w-3xl">
      <Reveal><p className="overline">Unser Sortiment</p></Reveal>
      <Reveal delay={0.05}>
        <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
          Produkte von Blum - Fussböden von heute und morgen
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="text-[#6B6B73] text-lg leading-relaxed mt-6">
          Wir bieten Ihnen ein vielfältiges Programm der unterschiedlichsten Produkte rund um
          Bodenbeläge aller Art an. Dabei legen wir besonderen Wert auf eine exakte Ausführung in
          enger Abstimmung mit unseren Kunden. Mit dieser Übersicht wollen wir Ihnen einen Einblick
          in die von uns verwendeten, ausgewählten Fussbodenbeläge geben. Selbstverständlich stehen
          wir Ihnen auch unabhängig davon für eine Beratung rund um den richtigen Fussboden zur
          Verfügung.
        </p>
      </Reveal>
    </div>
  </section>
);

export default function Produkte() {
  useSeo(
    "Produkte von Fussboden Blum",
    "Produkte von Blum - Fussböden von heute und morgen für unsere Kunden. Erfahren Sie mehr über unsere ausgewählten Fussböden."
  );

  return (
    <div data-testid="produkte-page">
      <Navbar />
      <main>
        <ProdukteHero />
        <Intro />
        <div className="border-t border-[#E5E0D8]">
          <FloorFinder />
        </div>
      </main>
      <Footer />
    </div>
  );
}
